export default __webpack_public_path__ + "static/media/icon_system.ef53cadb.svg";